<form [formGroup]="form" (ngSubmit)="checkIfEmailIsChanged()">
    <div class="card floating shadow-lg">
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <h3 class="main-title card-title">
                        Profile<br>
                        <small>
                            All fields marked with an asterisk (*) are required.
                        </small>
                    </h3>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <h4>Personal Information</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="firstName" type="text"
                            *ngIf="app.config.enablePermanentDataEditing">
                        <input matInput disabled readonly formControlName="firstName" type="text"
                            *ngIf="!app.config.enablePermanentDataEditing">
                        <mat-error *ngIf="formGroup.firstName.touched && formGroup.firstName.errors ">
                            {{formControlErrorMessage('firstName')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="lastName" type="text"
                            *ngIf="app.config.enablePermanentDataEditing">
                        <input matInput disabled readonly formControlName="lastName" type="text"
                            *ngIf="!app.config.enablePermanentDataEditing">
                        <mat-error *ngIf="formGroup.lastName.touched && formGroup.lastName.errors ">
                            {{formControlErrorMessage('lastName')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="dateOfBirth" formControlName="dateOfBirth"
                            *ngIf="app.config.enablePermanentDataEditing">
                        <input matInput disabled readonly [matDatepicker]="dateOfBirth" formControlName="dateOfBirth"
                            type="text" *ngIf="!app.config.enablePermanentDataEditing">
                        <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #dateOfBirth></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline" *ngIf="app.config.enablePermanentDataEditing">
                        <mat-label>Gender at Birth</mat-label>
                        <mat-select formControlName="gender">
                            <mat-option *ngFor="let gender of genders" [value]="gender.value">
                                {{gender.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <input disabled readonly formControlName="gender" type="text" style="display:none"
                        *ngIf="!app.config.enablePermanentDataEditing">
                    <mat-form-field appearance="outline" *ngIf="!app.config.enablePermanentDataEditing">
                        <mat-label>Gender at Birth</mat-label>
                        <input matInput disabled readonly type="text" formControlName="gender1" value='Male'
                            *ngIf="formGroup.gender.value==1">
                        <input matInput disabled readonly type="text" formControlName="gender1" value='Female'
                            *ngIf="formGroup.gender.value==2">
                        <input matInput disabled readonly type="text" formControlName="gender1" value='Others'
                            *ngIf="formGroup.gender.value==0">
                        <input matInput disabled readonly type="text" formControlName="gender1" value='Others'
                            *ngIf="formGroup.gender.value==null">
                        <input matInput disabled readonly type="text" formControlName="gender1" value='Others'
                            *ngIf="formGroup.gender.value==undefined">
                    </mat-form-field>
                </div>
            </div>


            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" type="text">
                        <mat-error *ngIf="formGroup.email.touched && formGroup.email.errors ">
                            {{formControlErrorMessage('email')}}</mat-error>
                        <mat-hint *ngIf="app.customer.status == 2">
                            <a class="resend" (click)="verifyEmailAddress()">Verify your email address</a>                           
                        </mat-hint>
                    </mat-form-field> <br *ngIf="app.customer.status == 2"><br *ngIf="app.customer.status == 2">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 d-none">
                    <mat-form-field appearance="outline">
                        <mat-label>Do you have an Australian No.?</mat-label>
                        <mat-select formControlName="isAustralianPhoneNumber"
                            (selectionChange)="formGroup.mobilePhoneNumber.setValue('');">
                            <mat-option *ngFor="let gender of yesNo" [value]="gender.value">
                                {{gender.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Mobile Phone</mat-label>
                        <input matInput formControlName="mobilePhoneNumber" type="text"
                            [maxLength]="formGroup.isAustralianPhoneNumber!=null && formGroup.isAustralianPhoneNumber.value ? 11:100">
                        <mat-error *ngIf="formGroup.mobilePhoneNumber.touched && formGroup.mobilePhoneNumber.errors">
                            {{formControlErrorMessage('mobilePhoneNumber')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Health Fund</mat-label>
                        <mat-select formControlName="healthFundId">
                            <mat-option *ngFor="let item of healthFunds" [value]="item.healthFundId">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <h4>
                        Address<br>
                        <small>Please ensure your residential address is current and corresponding to your
                            Medicare and/or Private Health Insurance records. No Po Box acceptable.</small>
                    </h4>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Address 1*</mat-label>
                        <input matInput formControlName="address1" type="text" (click)="showAddressNotification()"
                            (keypress)="onAddress1Change($event.target.value)">
                        <mat-error *ngIf="formGroup.firstName.touched && formGroup.firstName.errors ">
                            {{formControlErrorMessage('firstName')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>State*</mat-label>
                        <mat-select formControlName="stateId">
                            <mat-option *ngFor="let item of states" (click)="onStateOptionClicked(item)"
                                [value]="item.stateId">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Suburb*</mat-label>
                        <mat-select formControlName="address4">
                            <mat-option *ngFor="let item of selectedState.suburbs" (click)="onSuburbOptionClicked(item)"
                                [value]="item.name">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-6 d-none">
                    <mat-form-field appearance="outline">
                        <mat-label>Suburb</mat-label>
                        <input matInput type="text" formControlName="address4" [matAutocomplete]="suburbAuto"
                            (input)="filterSuburb($event.target.value)">
                        <mat-autocomplete #suburbAuto="matAutocomplete">
                            <cdk-virtual-scroll-viewport itemSize="15" minBufferPx="240" maxBufferPx="720"
                                [ngStyle]="{'height.px': filteredSuburbs?.length < 10 ? filteredSuburbs?.length * 48 : 48*4 }">
                                <mat-option (click)="onSuburbOptionClicked(suburb)"
                                    *cdkVirtualFor="let suburb of filteredSuburbs; templateCacheSize: 50"
                                    [value]="suburb.name">
                                    {{suburb.name}}
                                </mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-autocomplete>
                        <mat-error>{{formControlErrorMessage('address4')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Postcode*</mat-label>
                        <input matInput formControlName="postCode" type="text">
                        <mat-error *ngIf="formGroup.postCode.touched && formGroup.postCode.errors ">
                            {{formControlErrorMessage('postCode')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Country*</mat-label>
                        <mat-select formControlName="countryId">
                            <mat-option *ngFor="let item of countries" [value]="item.countryId">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="card-footer nav-footer">
                <div class="col-sm-12 text-center">
                    <input type="button" class="btn btn-blue" value="Back" (click)="back(false)">
                    <input type="submit" class="btn btn-blue" value="Update">                    
                </div>
            </div>
        </div>
    </div>
</form>
<br>


<ng-template #addressNotesDialog>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Message</h4>
    </div>
    <div class="modal-body">
        <p>PLEASE ENSURE YOUR RESIDENTIAL ADDRESS IS CURRENT AND CORRESPONDING TO YOUR MEDICARE AND /OR PRIVATE HEALTH
            INSURANCE RECORDS. NO PO BOX ACCEPTABLE.</p>
    </div>
    <div class="modal-footer">
        <a class="btn btn-blue" (click)="closeDialog()">Okay</a>
    </div>
</ng-template>